export function assertInitializedQuoteProducts(
  quoteDetails: readonly { productid: { productid: string } }[],
  expectedProductIds: readonly string[]
) {
  for (const productId of expectedProductIds) {
    const count = quoteDetails.filter((detail) => detail.productid.productid === productId).length
    if (count !== 1) {
      throw new Error(`Quote initialization expected one ${productId} row; found ${count}. Refresh before editing.`)
    }
  }
}
